import gql from 'graphql-tag';

export default gql`
  query ArtistStats {
    artistStats {
      specialty,
      profession,
      count
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/ArtistStats.js